import { Users, Package, CheckCircle2, TrendingUp } from "lucide-react"

export type PatientStat = {
  label: string
  value: string
  trend: number
  trendLabel: string
  trendDirection: "up" | "down"
  icon: any
}

export type Patient = {
  id: string
  name: string
  email: string
  insurance: string
  phoneNumber: string
  emiratesId: string
  queue: string
  lastVisit: string
  status: "Active" | "Inactive"
}

export const statsData: PatientStat[] = [
  {
    label: "Total Patients",
    value: "75,421",
    trend: 8.9,
    trendLabel: "+0.89% this week",
    trendDirection: "up",
    icon: Users
  },
  {
    label: "Dispensed",
    value: "12,398",
    trend: 4.2,
    trendLabel: "+0.67% this week",
    trendDirection: "up",
    icon: Package
  },
  {
    label: "Lost Customer",
    value: "2,579",
    trend: 1.23,
    trendLabel: "-0.32% this week",
    trendDirection: "down",
    icon: CheckCircle2
  },
  {
    label: "Avg Adherence",
    value: "2,547",
    trend: 0.5,
    trendLabel: "+0.05% this week",
    trendDirection: "up",
    icon: TrendingUp
  }
]

export const patientsData: Patient[] = [
  {
    id: "1",
    name: "Aiden Garcia",
    email: "aiden.garcia@example.com",
    insurance: "Qatar Insurance Company",
    phoneNumber: "555-0100",
    emiratesId: "784-529-1357-4920",
    queue: "CMC-34",
    lastVisit: "2024-05-01",
    status: "Active"
  },
  {
    id: "2",
    name: "Isabella Rodriguez",
    email: "isabella.rodriguez@example.com",
    insurance: "Oman Insurance Company",
    phoneNumber: "555-0101",
    emiratesId: "784-529-8642-9175",
    queue: "G-34",
    lastVisit: "2024-05-05",
    status: "Active"
  },
  {
    id: "3",
    name: "Ethan Martinez",
    email: "ethan.martinez@example.com",
    insurance: "Dubai Insurance Company",
    phoneNumber: "555-0102",
    emiratesId: "784-529-2468-1357",
    queue: "F1-45",
    lastVisit: "2024-05-10",
    status: "Active"
  },
  {
    id: "4",
    name: "Mia Anderson",
    email: "mia.anderson@example.com",
    insurance: "Arabia Insurance Company",
    phoneNumber: "555-0103",
    emiratesId: "784-529-9753-2468",
    queue: "L-34",
    lastVisit: "2024-05-15",
    status: "Active"
  },
  {
    id: "5",
    name: "Jackson Thomas",
    email: "jackson.thomas@example.com",
    insurance: "Al Ain Ahlia Insurance Company",
    phoneNumber: "555-0104",
    emiratesId: "784-529-3691-8024",
    queue: "M-19",
    lastVisit: "2024-05-01",
    status: "Active"
  },
  {
    id: "6",
    name: "Aiden Garcia",
    email: "aiden.garcia@example.com",
    insurance: "Abu Dhabi National Insurance Company",
    phoneNumber: "555-0105",
    emiratesId: "784-529-6385-7193",
    queue: "Ortho - 34",
    lastVisit: "2024-05-01",
    status: "Active"
  },
  {
    id: "7",
    name: "Isabella Rodriguez",
    email: "isabella.rodriguez@example.com",
    insurance: "Al Sagr National Insurance Company",
    phoneNumber: "555-0106",
    emiratesId: "784-529-1037-6284",
    queue: "P - 20",
    lastVisit: "2024-05-05",
    status: "Active"
  },
  {
    id: "8",
    name: "Mia Anderson",
    email: "mia.anderson@example.com",
    insurance: "United Insurance Company",
    phoneNumber: "555-0107",
    emiratesId: "784-529-4729-5371",
    queue: "-",
    lastVisit: "2024-05-15",
    status: "Active"
  }
]
